import { BulkTradeRunStates } from './bulkTradeRunStates';

export const BULK_TRADER_UI_ONLY_STATES = {
  REVIEW_TRADE_ALLOCATIONS: 'REVIEW_TRADE_ALLOCATIONS',
  REVIEW_PTF_TRADE_ALLOCATIONS: 'REVIEW_PTF_TRADE_ALLOCATIONS',
} as const;

export type BulkTraderUiOnlyState =
  (typeof BULK_TRADER_UI_ONLY_STATES)[keyof typeof BULK_TRADER_UI_ONLY_STATES];

/** Preserve UI-only review steps when fetchBulkTradeRun refetches without a backend transition. */
export const syncActiveStateFromBulkTradeRun = (
  previousState: BulkTradeRunStates | BulkTraderUiOnlyState | undefined,
  bulkTradeRunState: BulkTradeRunStates,
): BulkTradeRunStates | BulkTraderUiOnlyState => {
  if (!previousState) return bulkTradeRunState;
  if (previousState === bulkTradeRunState) return previousState;

  if (
    previousState === BULK_TRADER_UI_ONLY_STATES.REVIEW_TRADE_ALLOCATIONS &&
    bulkTradeRunState === BulkTradeRunStates.BULK_TRADES_COMPLETED
  ) {
    return previousState;
  }

  if (
    previousState === BULK_TRADER_UI_ONLY_STATES.REVIEW_PTF_TRADE_ALLOCATIONS &&
    bulkTradeRunState === BulkTradeRunStates.COMPLETED_PENDING_PTFS
  ) {
    return previousState;
  }

  return bulkTradeRunState;
};

export const BULK_TRADER_POLLING_STATES = new Set<BulkTradeRunStates>([
  BulkTradeRunStates.GENERATING,
  BulkTradeRunStates.BULK_TRADES_FILES_GENERATING,
  BulkTradeRunStates.BULK_TRADES_REQUESTED,
  BulkTradeRunStates.ALLOCATIONS_INITIATED,
  BulkTradeRunStates.ALLOCATIONS_REQUESTED,
]);

export type BulkTradeRunPollingDecision = 'start' | 'stop' | 'noop';

/** Polling is driven by `bulkTradeRun.state` only — not lagging UI `activeState`. */
export const resolveBulkTradeRunPolling = (
  state: BulkTradeRunStates | undefined,
  stepIndex: number,
  firstStepperStepIndex = 0,
): BulkTradeRunPollingDecision => {
  if (!state) return 'noop';

  if (
    state === BulkTradeRunStates.COMPLETED ||
    state === BulkTradeRunStates.CANCELED
  ) {
    return 'stop';
  }

  if (BULK_TRADER_POLLING_STATES.has(state)) {
    return 'start';
  }

  if (stepIndex > firstStepperStepIndex) {
    return 'stop';
  }

  return 'noop';
};
